"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({ error }) {
  useEffect(() => {
    Sentry.captureException(error);
    const message = error?.message || "";
    if (
      typeof window !== "undefined" &&
      (message.includes("insertBefore") ||
        message.includes("removeChild") ||
        message.includes("is not a child of this node"))
    ) {
      try {
        const last = Number(sessionStorage.getItem("__dom_error_reloaded_at") || 0);
        if (Date.now() - last > 10000) {
          sessionStorage.setItem("__dom_error_reloaded_at", String(Date.now()));
          window.location.reload();
        }
      } catch (_) {
        window.location.reload();
      }
    }
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
